export interface ExternalEffectsColumn {
  id: string;
  label: string;
  minWidth?: number;
  align?: "left" | "center" | "right";
}

export const TABLE_HEADER_CELL_FONT_SIZE = "1.2rem";
export const TABLE_BODY_CELL_FONT_SIZE = "1.0rem";
